import { Counter, Row } from '@ui';
import type { ReactNode } from 'react';
import { ChevronIcon } from './icons';

/** A section of the report panel that opens its body: the library row with `aria-expanded`, actions at the right edge. */
export function Fold({ title, count, open, onToggle, children, aside }: { title: string; count?: number; open: boolean; onToggle: () => void; children: ReactNode; aside?: ReactNode }) {
  return (
    <Row
      className={`bug-fold${open ? ' bug-fold-open' : ''}`}
      density="comfortable"
      title={<b>{title}</b>}
      meta={
        <>
          {count ? <Counter value={count} tone="accent" /> : null}
          <ChevronIcon open={open} />
        </>
      }
      end={aside}
      expanded={open}
      onClick={onToggle}
    >
      {open && <div className="bug-fold-body">{children}</div>}
    </Row>
  );
}
